/* eslint-disable */
import { Configuration, PerformoSettings, User as PerformoUser, PartsApi, CompaniesApi, ContactsApi, DocumentsApi, UsersApi, WorkersApi, WorkordersApi, AssetsApi, SystemApi, ReportsApi, PropertiesApi, BuildingsApi, Property, CostsApi, MetersApi } from 'performo-api';
import { GlobalErrorDisplay } from '@/models/GlobalErrorDisplay';
import { User } from 'oidc-client';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appTitle: '',
    systemName: '',
    developmentMode: false,
    user: <User>{},
    performoUser: <PerformoUser>{},
    settings: <PerformoSettings>{},
    currentPropertyId: '',
    currentProperty: <Property>{},
    currentGlobalError: <GlobalErrorDisplay | null>null,
  },
  getters: {
    assetsApi: state => new AssetsApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    buildingsApi: state => new BuildingsApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    costsApi: state => new CostsApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    companiesApi: state => new CompaniesApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    contactsApi: state => new ContactsApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    documentsApi: state => new DocumentsApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    ordersApi: state => new WorkordersApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    partsApi: state => new PartsApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    usersApi: state => new UsersApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    systemApi: state => new SystemApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    reportsApi: state => new ReportsApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    workersApi: state => new WorkersApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    propertiesApi: state => new PropertiesApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    metersApi: state => new MetersApi(new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token })),
    currentPropertyId: state => state.currentPropertyId ? state.currentPropertyId : state.user.profile.PropertyId.split('\r')[ 0 ],
    currentUser: state => state.user ? state.user : null,
    isLoggedIn: state => state.user !== null && state.user.expired === false,
    globalStateLoaded: state => state.settings.fmRecordId ? true : false,
    accessToken: state => state.user ? state.user.access_token : '',
    userDisplayName: state => state.user.profile ? state.user.profile.name : '',
    userId: state => state.user.profile ? state.user.profile.sub : '',
    getApiConfiguration: state => new Configuration({ basePath: window.location.origin, accessToken: 'Bearer ' + state.user.access_token }),
    settings: state => state.settings ? state.settings : null,
    performoUser: state => state.performoUser ? state.performoUser : null,
    currentError: state => state.currentGlobalError,
    currentProperty: state => state.currentProperty ? state.currentProperty : null
  },
  mutations: {
    setError(state, error: GlobalErrorDisplay) {
      state.currentGlobalError = error;
    },
    setErrorClear(state) {
      state.currentGlobalError = null;
    },
    setSettings(state, settings: PerformoSettings) {
      state.settings = settings;
    },
    setPerformoUser(state, user: PerformoSettings) {
      state.performoUser = user;
    },
    setUser(state, newUser: User) {
      state.user = newUser;
    },
    toggleDevMode(state) {
      state.developmentMode = !state.developmentMode;
    },
    setCurrentPropertyId(state, propertyId: string) {
      if (propertyId) {
        state.currentPropertyId = propertyId.trim();
      }
    },
    setAppTitle(state, title: string) {
      state.appTitle = title;
      window.document.title = title;
    },
    setSystemName(state, name: string) {
      state.systemName = name;
    },
    setCurrentProperty(state, property: Property) {
      state.currentProperty = property;
    }
  },
  actions: {
  },
  modules: {
  }
});
